import { ArrowIcon, DoubleHalfCircleIcon } from '@nwwp/ui-shadcn'
import { LINKS } from '~/utils/links'
import type { FunnelStepTerminalComponent } from '../../types'
import { CalendlyScheduler } from '../CalendlyScheduler'
import { FunnelStep } from '../FunnelStep'

export const Schedule: FunnelStepTerminalComponent = () => (
  <FunnelStep.Terminal data-testid="schedule">
    <div className="flex flex-col gap-4">
      <h1 className="text-title-xl text-center text-white tablet:text-left">Schedule a 30-min call now</h1>
      <div className="flex items-center justify-center gap-6 tablet:justify-start">
        <ArrowIcon />
        <h1 className="text-title-xl text-white">It&rsquo;s free</h1>
        <DoubleHalfCircleIcon className="translate-y-1 scale-75 tablet:scale-100" />
      </div>
      <p className="text-body text-white">
        If a time is not selected, NerdWallet Wealth Partners or its representatives will follow-up with you to find a
        more convenient time for a call.
      </p>
    </div>
    <CalendlyScheduler url={LINKS.FUNNEL_CALENDLY_LINK} />
  </FunnelStep.Terminal>
)

Schedule.path = 'schedule'
